export default __webpack_public_path__ + "static/univers-bold-55e1dfc0f3899115fc4bf7d227fbd8d3.woff2";